// DL-61835 (QA 2507004): mirrors the D2 -> legacy `_auth0org` param the iframe already appends
// (features/iframe/utils/index.ts) for the reverse hop. Legacy's "Try Delogue 2.0" link now
// appends this same param (LoginApiController.GetBetaSiteURL) so D2 knows an org was already
// chosen on the legacy side instead of falling back to its own org picker.
export const LEGACY_ORG_HINT_PARAM = '_auth0org';

export const getLegacyOrgHint = (): string | null =>
  new URLSearchParams(window.location.search).get(LEGACY_ORG_HINT_PARAM);
